import { render, staticRenderFns } from "./RegisterStep_2.vue?vue&type=template&id=8c6e65b8&scoped=true&"
import script from "./RegisterStep_2.vue?vue&type=script&lang=js&"
export * from "./RegisterStep_2.vue?vue&type=script&lang=js&"
import style0 from "./RegisterStep_2.vue?vue&type=style&index=0&id=8c6e65b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c6e65b8",
  null
  
)

export default component.exports